import { LinkButton } from '@/components/elements/forms/buttons';
import { config } from '@/config';
import { getContainmentMode } from '@/helpers/containmentPolicy';
import { _t } from '@/locale';

const baseKey = 'features.bookingWidget.EntryError';

/**
 * What an entry that resolves to nothing leaves behind — the Place is
 * unreachable with no Portal to fall back on, or the Portal's own locations
 * cannot be fetched. Both contained surfaces render it, in the merchant's
 * theme, and only a Linked Session gets a way out: the framed widget is a
 * panel on the merchant's own page, which is where its visitor already is.
 *
 * The Exit is an absolute href, so it is a document navigation: the start page
 * is not a route in this SPA, and the Linked Session ends because the document
 * unloads. `config.baseUrl` and `url.getBaseUrl()` are the same value in the
 * browser — both resolve the `_BASE_URL` the embed route injects.
 */
const EntryError = (): JSX.Element => (
  <div className="gap-3xl px-xl py-3xl bg-surface_mp min-h-viewport flex w-full flex-col items-center justify-center">
    <h1 className="text-h-xl text-fg_primary text-center font-bold">{_t(`${baseKey}.error`)}</h1>
    {getContainmentMode() === 'linked' && (
      <LinkButton variant="primary" size="md" to={config.baseUrl}>
        {_t(`${baseKey}.home`)}
      </LinkButton>
    )}
  </div>
);

export default EntryError;
